jQuery(function($) {
	var surpriseMenu = $('.surprise-menu');

	// Loads the surprise menu that is indicated by the URL. By always using the
	// URL, we are guaranteed to get the same result that would be shown upon a
	// full page reload.
	function loadSurpriseMenu() {
		console.log(window.location);
		var url = new URL(window.location);
		var date = url.searchParams.get('surprise_date');
		var seed = url.searchParams.get('surprise_seed');

		surpriseMenu.addClass('loading');
		$.get({url: '/wp-json/veganchallenge/v1/surprise_menu?surprise_date=' + date + '&surprise_seed=' + seed})
			.done(function(response) {
				surpriseMenu.html(response.html);
			})
			.always(function() {
				surpriseMenu.removeClass('loading');
			});
	}

	$('.new-surprise-menu').on('click', function(e) {
		e.preventDefault();

		var date = new Date().toISOString().substr(0, 10);
		var seed = Math.floor(Math.random() * 0xffffffff);

		var url = new URL(window.location);
		url.searchParams.set('surprise_date', date);
		url.searchParams.set('surprise_seed', seed);
		window.history.pushState(null, document.title, url.toString());

		loadSurpriseMenu();
	});

	if (surpriseMenu.length > 0) {
		window.addEventListener('popstate', function(event) {
			loadSurpriseMenu();
		});
	}
});
